import styled from 'styled-components'
import TextFieldMui from 'src/components/TextFieldMui'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

export const ReportButton = styled(ErrorOutlineIcon)`
  margin-top: 70px;
  margin-right: 8px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
`

export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const FormHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
`

export const FormTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media (max-width: 768px) { padding-top: 16px; }
`

export const Container = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 500px;
  padding: 8px;
`

export const ButtonSection = styled.div`
  width: 100%;
  display: flex;
`

export const CustomFieldMui = styled(TextFieldMui)`
  margin-top: 8px !important;
`

export const ProductInfo = styled.p`
  display: flex;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
`

export const ProductInfoBox = styled.p`
  background-color: #839BCB;
  font-weight: bold;
  font-size: 14px;
  border: 1px;
  border-style: solid;
  border-color: black;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 8px 8px 8px 8px;
`
